import { render, staticRenderFns } from "./GisOrangehomeGalleryBaseinfoList.vue?vue&type=template&id=a535d5e0&scoped=true&"
import script from "./GisOrangehomeGalleryBaseinfoList.vue?vue&type=script&lang=js&"
export * from "./GisOrangehomeGalleryBaseinfoList.vue?vue&type=script&lang=js&"
import style0 from "./GisOrangehomeGalleryBaseinfoList.vue?vue&type=style&index=0&id=a535d5e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a535d5e0",
  null
  
)

export default component.exports